import 'fullcalendar';
import moment from 'moment'
import 'fullcalendar/dist/locale/ja.js';
export function calendarFunc() {
    var dt, y, m, d, setDateResult, jsonDestination, setJsonRes;
    dt = new Date();
    y = dt.getFullYear();
    m = ("00" + (dt.getMonth() + 1)).slice(-2);
    d = ("00" + dt.getDate()).slice(-2);
    setDateResult = y + "-" + m + "-" + d;
    jsonDestination = '/fanclub/schedules/get';

    $('.overlay').on('click', function () {
        $.when(
            $('#scheduleModalLayout').fadeOut('500'),
        ).done(function () {
            $('#setEvent').empty();
        });
    });

    $('#closeBtn').on('click', function () {
        $.when(
            $('#scheduleModalLayout').fadeOut('500'),
        ).done(function () {
            $('#setEvent').empty();
        });
    });


    var modalWindowFunc, setFilter;
    modalWindowFunc = function (outputResult) {
        $('#setEvent').append(outputResult);
        $('#scheduleModalLayout').fadeIn('500');
    }

    var getAjaxEventData;
    getAjaxEventData = function (date) {
        $.ajax({
            url: '/fanclub/schedules/find_by_date',
            method: 'get',
            dataType: 'html',
            data: {
                date: date,
            },
       }).done(function (res) {
           modalWindowFunc(res)
       }).fail(function (xhr, textStatus, errorThrown) {
           console.log("NG:" + xhr.status);
       });
   }

    var calendarSetFunc, selectDateRes;
    calendarSetFunc = function () {
        //カレンダー入力
        $('#eventCalendar').fullCalendar({
            header: {
                left: 'title,prev',
                center: 'title',
                right: 'today,next'
            },
            defaultDate: setDateResult,
            buttonIcons: true,
            weekNumbers: false,
            navLinks: false,
            editable: false,
            eventLimit: false,
            contentHeight: 'auto',
            timeFormat: 'H:mm',
            events: {
                url: jsonDestination,
            },
            eventRender: function (events, element) {
                if (events.other == false) {
                    $(element[0]).html('<div class="minesEvent" data-date="' + events.start.format('YYYY-MM-DD') + '">minesEvent</div>');
                } else if (events.other == true) {
                    $(element[0]).html('<div class="externalEve" data-date="' + events.start.format('YYYY-MM-DD') + '">externalEve</div>');
                }
            },
            dayClick: function (date, jsEvent, view) {
                var dataAttr = '[data-date='+date.format('YYYY-MM-DD')+']';
                if( $('div.minesEvent'+dataAttr+', div.externalEve'+dataAttr).length ) {
                    $('#eventDay').text(date.format('YYYY年MM月DD日'));
                    getAjaxEventData(date.format('YYYY-MM-DD'));
                }
            },
            eventClick: function (info) {
                $('#eventDay').text(info.date);
                getAjaxEventData( info.date.replace(/(年|月)/g, '-').replace('日','') );
            }
        });
    }
    calendarSetFunc();

    //年月取得処理
    var fcCenter, fcLeft, getDayData, ArrDayData, getYear, getMonth;
    fcCenter = $('.fc-center');
    fcLeft = $('.fc-left');
    ArrDayData = [];

    function getDataFunc() {
        getDayData = fcCenter.find('h2').text();
        ArrDayData = getDayData.split(" ");
        //年を取得
        getYear = ArrDayData[0].replace(/[^0-9]/g, '');
        //月を取得
        getMonth = ArrDayData[1];
        fcCenter.find('h2').text(getMonth);
        fcLeft.find('h2').text(getYear);
    }

    var getW, gwtH, getSkeH;

    function getEventDesignFunc() {
        getW = $('.fc-row').outerWidth(true);
        gwtH = getW / 7;
        getSkeH = $('.fc-content-skeleton').outerHeight(true);
        $('.fc-event-container').css('width', gwtH).css('height', getSkeH - 2);
    }
    //next,prev,今日ボタン押下時の書き換え
    var moveBtn;
    moveBtn = $('.fc-prev-button, .fc-next-button, .fc-today-button');
    moveBtn.on('click', function () {
        getDataFunc();
    });

    getDataFunc();
}
